// extracted by mini-css-extract-plugin
export default {"list":"list___bac67ca30ce05a77","control":"control___aca5b576228773d8","answer":"answer___bfe4ed8942bd5d0b","label":"label___f09eb1f18c912756","field":"field___ef7b6f35b9adb641"};